import writeXlsxFile from "write-excel-file";
import { getMatch } from "../../../utils/services/match";

export async function createByLineXlsx(props) {
  const {
    idEvent,
    limit,
    countData,
    codeQrcode,
    empresa,
    cargo,
    code1,
    code2,
    code3,
    group,
    setFinishExport,
  } = props;

  const formatDate = (date) => {
    try {
      if (!date) return "";

      const formatedDate = date.split("T")[0].split("-").reverse().join("/");
      const formatTime = date.split("T")[1].split(".")[0];

      return `${formatedDate} ${formatTime}`;
    } catch (error) {
      return date;
    }
  };

  const schema = [
    {
      column: "Quantidade",
      type: String,
      value: (match) => match.index,
    },
    {
      column: "Nome Completo",
      type: String,
      value: (match) => match.name,
    },
    {
      column: "Email",
      type: String,
      value: (match) => match.email,
    },
    {
      column: "Restrição de Hospedagem",
      type: String,
      value: (match) => match.restriction,
    },
    {
      column: codeQrcode ? "Código QRCode" : null,
      type: String,
      value: (match) => match.codeQrcode,
    },
    {
      column: empresa ? "Empresa" : null,
      type: String,
      value: (match) => match.enterprise,
    },
    {
      column: cargo ? "Cargo" : null,
      type: String,
      value: (match) => match.position,
    },
    {
      column: code1 ? "Código Interno 1" : null,
      type: String,
      value: (match) => match.cod1,
    },
    {
      column: code2 ? "Código Interno 2" : null,
      type: String,
      value: (match) => match.cod2,
    },
    {
      column: code3 ? "Código Interno 3" : null,
      type: String,
      value: (match) => match.cod3,
    },
    {
      column: group ? "Grupo(s)" : null,
      type: String,
      value: (match) => match.groups,
    },
    {
      column: "Status",
      type: String,
      value: (match) =>
        match.status === "completed" ? "Completo" : "Pendente",
    },
    {
      column: "Data e Hora da Criação",
      type: String,
      value: (match) => match.createdAt,
    },
  ];

  const numberOfRequisitions = Math.ceil(countData / limit);

  let allRequests = [];

  for (let i = 1; i <= numberOfRequisitions; i++) {
    const request = await getMatch({
      eventId: idEvent,
      offset: i,
      limit: limit,
      search: "",
    });

    allRequests.push(...request.data);

    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");
    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0,
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }

  var dataFormated = [];

  if (allRequests.length > 0) {
    allRequests.map((e, i) => {
      dataFormated.push({
        name: e.login_nome_1,
        email: e.login_email_1,
        status: e.login_status_1,
        createdAt: formatDate(e.createdAt),
        index: `${i + 1}`,
        codeQrcode: e.codeqrcode_1 || "",
        enterprise: e.empresa_1 || "",
        position: e.cargo_1 || "",
        cod1: e.codigo_interno_1_1 || "",
        cod2: e.codigo_interno_2_1 || "",
        cod3: e.codigo_interno_3_1 || "",
        restriction: e.restricao_hospedagem_1,
        groups:
          e.grupos_id_1 && e.grupos_id_1.length > 0
            ? e.grupos_id_1.map((group) => group.name).join(", ")
            : "",
      });

      if (e.login_nome_2) {
        dataFormated.push({
          name: e.login_nome_2,
          email: e.login_email_2,
          status: e.login_status_2,
          createdAt: formatDate(e.createdAt),
          index: `${i + 1}`,
          codeQrcode: e.codeqrcode_2 || "",
          enterprise: e.empresa_2 || "",
          position: e.cargo_2 || "",
          cod1: e.codigo_interno_1_2 || "",
          cod2: e.codigo_interno_2_2 || "",
          cod3: e.codigo_interno_3_2 || "",
          restriction: e.restricao_hospedagem_2,
          groups:
            e.grupos_id_2 && e.grupos_id_2.length > 0
              ? e.grupos_id_2.map((group) => group.name).join(", ")
              : "",
        });
      }

      if (e.login_nome_3) {
        dataFormated.push({
          name: e.login_nome_3,
          email: e.login_email_3,
          status: e.login_status_3,
          createdAt: formatDate(e.createdAt),
          index: `${i + 1}`,
          codeQrcode: e.codeqrcode_3 || "",
          enterprise: e.empresa_3 || "",
          position: e.cargo_3 || "",
          cod1: e.codigo_interno_1_3 || "",
          cod2: e.codigo_interno_2_3 || "",
          cod3: e.codigo_interno_3_3 || "",
          restriction: e.restricao_hospedagem_3,
          groups:
            e.grupos_id_3 && e.grupos_id_3.length > 0
              ? e.grupos_id_3.map((group) => group.name).join(", ")
              : "",
        });
      }

      if (e.login_nome_4) {
        dataFormated.push({
          name: e.login_nome_4,
          email: e.login_email_4,
          status: e.login_status_4,
          createdAt: formatDate(e.createdAt),
          index: `${i + 1}`,
          codeQrcode: e.codeqrcode_4 || "",
          enterprise: e.empresa_4 || "",
          position: e.cargo_4 || "",
          cod1: e.codigo_interno_1_4 || "",
          cod2: e.codigo_interno_2_4 || "",
          cod3: e.codigo_interno_3_4 || "",
          restriction: e.restricao_hospedagem_4,
          groups:
            e.grupos_id_4 && e.grupos_id_4.length > 0
              ? e.grupos_id_4.map((group) => group.name).join(", ")
              : "",
        });
      }
    });
  }

  await writeXlsxFile(dataFormated, {
    schema: schema.filter((e) => e.column != null),
    fileName: "RelatorioQuartos.xlsx",
  });
}
